export class User {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  fullName: string;
  primaryMobileNumber: string;
  primaryEMail: string;
}
